import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useForm from '../../../Shared/hooks/useForm';
import { TransferConstant } from '../../TransferConstant';
import dollarSign from '../../../../assets/images/Dollar.svg';
import { incrementStep } from '../../../../redux/modules/transferFunding/stepActions';
import { setAmount } from '../../../../redux/modules/transferFunding/continueStep/continueActions';
import {
  SSJBeaconButton,
  SSJBeaconInputField,
  SSJBeaconErrorMessageSummary,
  SSJBeaconRadioGroup,
  SSJBeaconRadioButton,
  SSJBeaconDatePicker,
} from '../../../Shared/Beacon/Registry';

import rightArrow from '../../../../assets/images/beacon-chevron-right.svg';
import './TransferAmount.scss';
import { putFundingTrackingData } from '../../../../redux/modules/fundingTrackingData/fundingTrackingData.module';
import { beaconPattern } from '../../../../utils/fundingMethod/fundingMethodUtils';
import moment from 'moment';

const TransferAmountForm = () => {
  const radioButton1 = TransferConstant.transferAmountPage.fullTransferLabel;
  const radioButton2 = TransferConstant.transferAmountPage.partialTransferLabel;
  const radioButton3 = TransferConstant.transferAmountPage.earlyWithdrawLabel;
  const radioButton4 = TransferConstant.transferAmountPage.maturityLabel;
  const dispatch = useDispatch();
  const [partialTransfer, setPartialTransfer] = useState(false);
  const [maturityForm, setMaturityForm] = useState(false);
  const [maturityDateInp, setMaturityDateInp] = useState('');
  const fundingTrackingData = useSelector(
    (state) => state?.fundingTrackingData
  );

  const { values, errors, handleChange, handleSubmit, setValues } = useForm(
    {
      cashDollarValue:
        fundingTrackingData?.payload?.onboardingDataStore?.onboardingDatastoreTransfer?.cashDollarValue.toString() ||
        0,
      certificateOfDepositTransferType:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreTransfer?.certificateOfDepositTransferType || '',
      certificateOfDepositLiquidationTimeFrame:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreTransfer
          ?.certificateOfDepositLiquidationTimeFrame || '',
      certificateOfDepositMaturityDate:
        fundingTrackingData?.payload?.onboardingDataStore
          ?.onboardingDatastoreTransfer?.certificateOfDepositMaturityDate || '',
    },
    () => {
      fundingTrackingData.payload.onboardingDataStore.onboardingDatastoreTransfer =
        {
          ...fundingTrackingData.payload.onboardingDataStore
            .onboardingDatastoreTransfer,
          cashDollarValue:
            values.cashDollarValue === '' ? 0 : Number(values.cashDollarValue),
          certificateOfDepositTransferType:
            values.certificateOfDepositTransferType,
          certificateOfDepositLiquidationTimeFrame:
            values.certificateOfDepositLiquidationTimeFrame,
          certificateOfDepositMaturityDate:
            moment(values?.certificateOfDepositMaturityDate)
              .format('MM/DD/YYYY')
              .toUpperCase() === 'INVALID DATE'
              ? ''
              : moment(values?.certificateOfDepositMaturityDate).format(
                  'MM/DD/YYYY'
                ),
        };
      if (
        values.certificateOfDepositMaturityDate.toUpperCase() !== 'INVALID DATE'
      ) {
        dispatch(setAmount(values));
        dispatch(putFundingTrackingData(fundingTrackingData?.payload));
        dispatch(incrementStep());
      }
    }
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (values.certificateOfDepositLiquidationTimeFrame === 'UPON_MATURITY') {
      setMaturityForm(true);
    }
    if (values.certificateOfDepositTransferType === 'PARTIAL') {
      setPartialTransfer(true);
    }
  });

  const handleRadioChange1 = (event) => {
    values.certificateOfDepositTransferType = event.target.value;
    if (values.certificateOfDepositTransferType === 'PARTIAL') {
      setPartialTransfer(true);
    } else {
      setPartialTransfer(false);
      values.cashDollarValue = '';
    }
  };

  /* eslint-disable */
  useEffect(() => {
    if (values?.certificateOfDepositMaturityDate) {
      const date = moment(values?.certificateOfDepositMaturityDate).format(
        'YYYY-MM-DD'
      );
      setMaturityDateInp(`${date}`);
    }
  }, []);

  const handleRadioChange2 = (event) => {
    values.certificateOfDepositLiquidationTimeFrame = event.target.value;
    if (values.certificateOfDepositLiquidationTimeFrame === 'UPON_MATURITY') {
      setMaturityForm(true);
    } else {
      setMaturityForm(false);
      values.certificateOfDepositMaturityDate = '';
    }
  };

  const handleDateChange = (e) => {
    const date = moment(e.target.value).format('MM/DD/YYYY');
    if (date.toUpperCase() !== 'INVALID DATE') {
      setMaturityDateInp(`${moment(date).format('YYYY-MM-DD')}`);
      setValues({
        ...values,
        certificateOfDepositMaturityDate: `${date}`,
      });
      handleChange(e);
    }
  };

  const handleCashAssets = (event) => {
    values.cashDollarValue = event.target.value;
    if (Number(values.cashDollarValue) >= 1000) {
      handleChange(event);
    }
  };

  return (
    <div className="transfer-amount_page">
      <div className="transfer-amount_header">
        <h2 className="transfer-amount_heading">
          {TransferConstant.transferAmountPage.heading}
        </h2>
      </div>
      <div className="transfer-amount_descriptionHeader">
        <p className="transfer-amount_description">
          {TransferConstant.transferAmountPage.description}
        </p>
      </div>
      <div>
        {errors.length > 0 && (
          <div className="error-summary">
            <SSJBeaconErrorMessageSummary
              id="error-message-summary"
              errors={errors}
            />
          </div>
        )}
      </div>
      <div className="transfer-amount_instructHeader">
        <SSJBeaconRadioGroup
          name="certificateOfDepositTransferType"
          id="certificateOfDepositTransferType"
          label={TransferConstant.transferAmountPage.transferHeader}
          hint={TransferConstant.transferAmountPage.transferDesc}
          required="true"
          errors-map='{"required":"Transfer instruction is required!"}'
        >
          <SSJBeaconRadioButton
            name="fullTransfer"
            id="fullTransfer"
            label={radioButton1}
            value="FULL"
            checked={values.certificateOfDepositTransferType === 'FULL'}
            onClick={(e) => handleRadioChange1(e)}
          />
          <SSJBeaconRadioButton
            name="partialTransfer"
            id="partialTransfer"
            label={radioButton2}
            value="PARTIAL"
            checked={values.certificateOfDepositTransferType === 'PARTIAL'}
            onClick={(e) => handleRadioChange1(e)}
          />
        </SSJBeaconRadioGroup>
      </div>

      {partialTransfer && (
        <div className="transfer-amount_cd-partial-cash">
          <div className="transfer-amount_cd-partial-cash_line_line1">
            <SSJBeaconInputField
              id="cashDollarValue"
              name="cashDollarValue"
              label={TransferConstant.transferAmountPage.partialText}
              value={values.cashDollarValue}
              icon-position="left"
              icon-url={dollarSign}
              type="number"
              maxlength="15"
              min={1000}
              format={beaconPattern.sharesRegex}
              format-type="regexp"
              className="transfer-amount_cd-partial-cash_line_input-field"
              required={partialTransfer}
              errorsMap={{
                required: 'Cash assets to transfer is required',
                min: 'Please enter amount of $1000 or above',
                noMatchPattern: 'Please enter amount of $1000 or above',
              }}
              onBlur={(e) => handleCashAssets(e)}
            />
          </div>
        </div>
      )}

      <div>
        <SSJBeaconRadioGroup
          name="certificateOfDepositLiquidationTimeFrame"
          id="certificateOfDepositLiquidationTimeFrame"
          label={TransferConstant.transferAmountPage.timeFrameHeader}
          hint="Choose when you would like to liquidate your CDs prior to transfer."
          required="true"
          errors-map='{"required":"Liquidation time frame is required!"}'
        >
          <SSJBeaconRadioButton
            name="earlyWithdraw"
            id="earlyWithdraw"
            label={radioButton3}
            value="IMMEDIATELY"
            checked={
              values.certificateOfDepositLiquidationTimeFrame === 'IMMEDIATELY'
            }
            onClick={(e) => handleRadioChange2(e)}
          />
          <SSJBeaconRadioButton
            name="maturity"
            id="maturity"
            label={radioButton4}
            value="UPON_MATURITY"
            checked={
              values.certificateOfDepositLiquidationTimeFrame ===
              'UPON_MATURITY'
            }
            onClick={(e) => handleRadioChange2(e)}
          />
        </SSJBeaconRadioGroup>
      </div>

      {maturityForm && (
        <div className="transfer-amount_cd_date">
          <SSJBeaconDatePicker
            id="certificateOfDepositMaturityDate"
            name="certificateOfDepositMaturityDate"
            className="transfer-amount_cd_date_field"
            label={TransferConstant.transferAmountPage.maturityDateHeader}
            hint={TransferConstant.transferAmountPage.maturityDesc}
            value={maturityDateInp}
            required={maturityForm?.toString()}
            errors-map='{"required":"Maturity Date is invalid!"}'
            onBlur={(e) => handleDateChange(e)}
            min="1900-01-01"
            max="2050-01-01"
          />
        </div>
      )}

      <div className="transfer-amount_continueHeader">
        <SSJBeaconButton
          label={TransferConstant.transferAmountPage.continueButton}
          className="transfer-amount_continue"
          onClick={handleSubmit}
          scale="jumbo"
          iconAlign="right"
        >
          <img
            slot="icon"
            alt="Continue Button"
            className="continue-arrow-icon"
            fill="none"
            height="16"
            width="16"
            src={rightArrow}
          />
        </SSJBeaconButton>
      </div>
    </div>
  );
};

export default TransferAmountForm;
